module.exports = __webpack_public_path__ + "static/media/trashIcon.debea083.svg";